import { api_appuserinfo } from '@/api/login'
import { mapMutations } from 'vuex'
import Cookie from "js-cookie"

const userInfo = {
  data() {
    return {
    }
  },
  methods: {
    ...mapMutations('login',{
      SETAUTHORIZATION: 'SETAUTHORIZATION',
      SETUSERINFO: 'SETUSERINFO'
    }),
    testPhone(val) {
      const reg = /^[1]([3-9])[0-9]{9}$/
      return reg.test(val)
    },
    getAppuserinfo(data) {
      this.SETAUTHORIZATION(data)
      api_appuserinfo().then(res => {
        let data = JSON.parse(res.datas)
        this.SETUSERINFO(data)
        console.log('postMessage to other page')
        window.opener && window.opener.postMessage( 'loginEvent', '*' )
      })
    },
    getAppuserinfoTwo(data,callback) {
      this.SETAUTHORIZATION(data)
      api_appuserinfo().then(res => {
        let data = JSON.parse(res.datas)
        this.SETUSERINFO(data)
        console.log('postMessage to other page')
        window.opener && window.opener.postMessage( 'loginEvent', '*' )
        callback();
      })
    },
    goReturnUrl() {
      if (Cookie.get('returnURL')) {
        console.log(Cookie.get('returnURL'))
        location.href = Cookie.get('returnURL')
        Cookie.remove('returnURL')
        Cookie.remove('iCode')
      } else {
        location.href = process.env.MODE == 'pro' ? 'https://twinsearth.laozicloud.com' : 'https://twinsearth.laozicloud.net'
        // this.$router.push('/') 
        // window.location.reload();
      }
    },
    closePage() {
      window.opener = null
      window.open("", "_self")
      window.close()
    }
  }
}

export default userInfo
